module.exports = __webpack_public_path__ + "static/media/health-home-child-vac.9c54e556.svg";